// @flow
import React from 'react';
import { Sidebar, SidebarSection, NullState } from 'bench-internal-theme';
import { WrappedSpinner } from 'spinner';
import { useQuery } from '@apollo/client';
import { GET_LEDGER_ACCOUNT, GET_LEDGER_ACCOUNT_V2 } from '../queries';
// $FlowFixMe - TS file
import { apolloV2Client } from '../../../general-ledger/queries';
import { FeatureValue, useFeatureFlags } from '@bench/ff-client';
// $FlowFixMe - TS file
import { SplitFeatureFlags } from '../../features';
import LedgerAccountSidebarFormContainer from './LedgerAccountSidebarFormContainer';

type LedgerAccountSidebarProps = {
  closeSidebar: () => void,
  id?: string,
};

const LedgerAccountSidebar = ({ closeSidebar, id }: LedgerAccountSidebarProps) => {
  const [featureState] = useFeatureFlags();
  const {
    featureContext: { features },
  } = featureState;

  const isAssignCategoryImprovementEnabled =
    features[SplitFeatureFlags.ASSIGN_CATEGORY_IMPROVEMENT]?.value === FeatureValue.FEATURE_ON;

  // Use v2 query if feature flag is enabled, otherwise use v1
  const ledgerAccountQuery = isAssignCategoryImprovementEnabled
    ? GET_LEDGER_ACCOUNT_V2
    : GET_LEDGER_ACCOUNT;

  const { loading, error, data } = useQuery(ledgerAccountQuery, {
    variables: { id },
    skip: !id,
    ...(id && isAssignCategoryImprovementEnabled
      ? {
          client: apolloV2Client,
          context: { useV2: true },
        }
      : {}),
  });

  if (id && error) {
    return (
      <NullState
        bigEmoji="🙈"
        title="Uh oh! An error was encountered fetching the ledger account for this sidebar."
      />
    );
  }
  if (id && loading) {
    return <WrappedSpinner />;
  }
  const ledgerAccount = data?.ledgerAccount || undefined;

  return (
    <Sidebar
      dismiss={closeSidebar}
      headerContent={ledgerAccount ? 'Edit Ledger Account' : 'Create Ledger Account'}
    >
      <SidebarSection>
        <LedgerAccountSidebarFormContainer
          closeSidebar={closeSidebar}
          ledgerAccount={ledgerAccount}
        />
      </SidebarSection>
    </Sidebar>
  );
};

LedgerAccountSidebar.defaultProps = {
  id: undefined,
};

export default LedgerAccountSidebar;
